import {
  BackupStatus,
  ConditionOperatorEnum,
  type Condition,
} from '@repo/api-gw-sdk';

import { BACKUP_STATUS_PROPERTY } from '../queryBuilder/propertyNames';

export const NON_POSTURE_BACKUP_STATUSES: BackupStatus[] = [
  BackupStatus.ExcludedFromBackup,
  BackupStatus.Disconnected,
  BackupStatus.Unsupported,
  BackupStatus.LimitExceeded,
];

export const createBackupStatusNotInCondition = (
  values: string[]
): Condition => ({
  property: BACKUP_STATUS_PROPERTY,
  operator: ConditionOperatorEnum.NotIn,
  value: values,
});
